/**
 * ファイルを選ぶ欄（docs/06 4-2・総点検 M13）。
 *
 * ブラウザそのままの部品は、英語のブラウザでは「Choose File / No file chosen」と出て、
 * ほかの画面と見た目もそろいません。「ファイルを選ぶ」の控えのボタンと、選んだファイルの名前を
 * 言葉で出す形にそろえます。中身は本物の `<input type="file">` なので、キーボードでも
 * 読み上げでも、ふつうのファイル選びとして使えます（見た目だけを隠して重ねています）。
 */
import type { ReactNode, Ref } from 'react';

export interface FilePickerProps {
  id: string;
  /** 欄の見出し */
  label: string;
  /** 受け付けるファイルの種類（例 `.csv,text/csv`） */
  accept?: string;
  /** いま選んでいるファイル（無ければ null） */
  file: File | null;
  onChange: (file: File | null) => void;
  /** 選ぶボタンの言葉 */
  buttonLabel?: string;
  /** 選んだファイルを画面から外したいとき（取り込み後など）に使う */
  inputRef?: Ref<HTMLInputElement>;
}

export function FilePicker({
  id,
  label,
  accept,
  file,
  onChange,
  buttonLabel = 'ファイルを選ぶ',
  inputRef,
}: FilePickerProps): ReactNode {
  return (
    <div className="ui-field">
      <span id={`${id}-label`}>{label}</span>
      <div className="ui-file">
        <label className="ui-button ui-button-secondary ui-file-button" htmlFor={id}>
          {buttonLabel}
        </label>
        <input
          ref={inputRef}
          id={id}
          className="ui-file-input"
          type="file"
          aria-labelledby={`${id}-label`}
          {...(accept !== undefined ? { accept } : {})}
          onChange={(event) => onChange(event.target.files?.[0] ?? null)}
        />
        <span className="ui-file-name" aria-live="polite">
          {file ? file.name : 'まだ選んでいません'}
        </span>
      </div>
    </div>
  );
}
